import { Component, computed, inject } from "@angular/core";
import { Router } from "@angular/router";
import { TranslocoModule } from "@jsverse/transloco";
import { FavoriteStore } from "src/app/features/store/favorite-store";
import { Modal } from "src/app/shared/components/utils/modal/modal";

@Component({
  selector: "app-favorite-search-error-modal",
  imports: [Modal, TranslocoModule],
  templateUrl: "./favorite-search-error-modal.html",
})
export class FavoriteSearchErrorModal {
  private readonly router = inject(Router);
  private readonly favoriteStore = inject(FavoriteStore);

  isOpen = computed(() => this.favoriteStore.isFavoriteSearchesErrorModalOpen());

  close() {
    this.favoriteStore.setFavoriteSearchesErrorModalOpen(false);
  }

  closeAndRedirect() {
    this.close();
    this.router.navigate(["/user-profile"]);
  }
}
